<!-- environment-banner.component.html -->
<div *ngIf="bannerText" class="test-env-banner">
    {{ bannerText }}
</div>
